import { Component, computed, input } from '@angular/core';

type LineLoaderSize = 'sm' | 'md' | 'lg' | 'custom';

const LINE_LOADER_DURATION = 3;
@Component({
  selector: 'ol-line-loader',
  template: `
    <div [class]="lineLoaderClasses()" [style]="loaderStyles()">
      <div class="line-loader__line"></div>
    </div>
  `,
  styleUrls: ['./line-loader.component.scss'],
})
export class LineLoaderComponent {
  size = input<LineLoaderSize>('md');
  color = input<string>();

  animationDuration = input<number>(LINE_LOADER_DURATION);

  width = input<string>();
  height = input<string>();

  loaderStyles = computed(() => {
    return this.getLoaderStyles(this.size(), this.color(), this.animationDuration(), this.width(), this.height());
  });

  lineLoaderClasses = computed(() => {
    return `line-loader line-loader--${this.size()}`;
  });

  getLoaderStyles(
    size: LineLoaderSize,
    color: string,
    duration: number,
    width: string | undefined,
    height: string | undefined
  ) {
    const styles: Record<string, string> = {};

    if (size === 'custom') {
      if (width) styles['width'] = width;
      if (height) styles['height'] = height;
    }

    if (color) {
      styles['--loader-color'] = color;
    }

    styles['--loader-duration'] = duration + 's';

    return styles;
  }
}
